import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppDispatch, RootState } from "../store";
import { handleRequest } from "../utils/handleRequest";
import { notificationApi } from "../../api/notificationApi";
import { PaginationParameters } from "../../api/Pagination";
import { PaginatedData } from "../../hooks/PaginationHooks";
import { GenericInAppNotification, GenericInAppNotificationResponse } from "../../types/notificationType";


export const fetchInAppNotificationsThunk = createAsyncThunk<
    PaginatedData<GenericInAppNotificationResponse>,
    PaginationParameters,
    { dispatch: AppDispatch; state: RootState }
>(
    "notifications/fetchInAppNotifications",
    async (
        pagination,
        { dispatch }
    ) => {
        const result = await handleRequest(
            dispatch,
            "indirect",
            () => notificationApi.getGenericInAppNotifications(pagination)
        );
        if (result.success()) return result.result!;
        throw new Error(result.errorMessage ?? "Failed to fetch notifications");
    }
);

export const createNewNotificationThunk = createAsyncThunk<
    {},
    GenericInAppNotification,
    { dispatch: AppDispatch; state: RootState }
>(
    "notifications/createNewNotificationThunk",
    async (
        notification,
        { dispatch }
    ) => {
        const result = await handleRequest(
            dispatch,
            "direct",
            () => notificationApi.createGenericInAppNotification(notification)
        );
        if (result.success()) return result.result!;
        throw new Error(result.errorMessage ?? "Failed to create notificaiton");
    }
);

export const updateNotificationThunk = createAsyncThunk<
    {},
    GenericInAppNotification,
    { dispatch: AppDispatch; state: RootState }
>(
    "notifications/updateNotificationThunk",
    async (
        notification,
        { dispatch }
    ) => {
        const result = await handleRequest(
            dispatch,
            "direct",
            () => notificationApi.updateGenericInAppNotification(notification.id!, notification)
        );
        if (result.success()) return result.result!;
        throw new Error(result.errorMessage ?? "Failed to update notificaiton");
    }
);

export const deleteNotificationThunk = createAsyncThunk<
    {},
    GenericInAppNotification,
    { dispatch: AppDispatch; state: RootState }
>(
    "notifications/deleteNotificationThunk",
    async (
        notification,
        { dispatch }
    ) => {
        const result = await handleRequest(
            dispatch,
            "direct",
            () => notificationApi.deleteGenericInAppNotification(notification.id!)
        );
        if (result.success()) return result.result!;
        throw new Error(result.errorMessage ?? "Failed to delete notificaiton");
    }
);
